/* External */
import jwtDecode from 'jwt-decode';

export function createDeferredPromise(data = {}) {
  const deferred = { data };
  deferred.promise = new Promise(((resolve, reject) => {
    deferred.resolve = resolve;
    deferred.reject = reject;
  }));
  return deferred;
}

/**
 * @method isSessionExpired
 * @description  Method that validate if session token has been expired.
 * @param {string} currentSessionToken
 */
export function isSessionExpired(currentSessionToken) {
  const { exp } = jwtDecode(currentSessionToken);
  return Date.now() >= exp * 1000;
}

/**
 * @method isSessionExpired
 * @description  Method that validate if session token has been expired.
 * @param {string} currentSessionToken
 */
export function isAccessTokenExpired({ expireDate, expiresIn, timestamp }) {
  if (!expireDate && (!timestamp || !expiresIn)) return true;
  return Date.now() >= (expireDate || (timestamp + expiresIn * 1000));
}
